module.exports = __webpack_public_path__ + "img/06321409000781.db94676b.png";